

import React, { Component } from 'react';



import {
  View,
  Text,
  ActivityIndicator,
  Dimensions,
  TouchableOpacity,
  Linking

} from 'react-native';

//import AsyncStorage from '@react-native-community/async-storage';

import { Header, Icon } from 'react-native-elements';

import * as Animatable from 'react-native-animatable';
import {appstrings} from './translate/Strings';

import { WebView } from "react-native-webview";

import {Headerstyle,MainColor, Headerheight, HeaderAndFooterheight, support, urls} from './Controller';


export default class MyWebView extends Component {
constructor(props) {
    super(props);

    this.state = {

        close: urls.closewebview,
        testtext: '',
        isTablet: false,

    };
}

componentWillMount() {

}

componentWillUnmount() {

}



_onNavigationStateChange(webViewState){
  if ( webViewState.url === this.state.close ){
        this.goBack();
  }
  this.setState({ testtext: webViewState.url });
}

ActivityIndicatorLoadingView() {

    return (

      <ActivityIndicator
        color={MainColor.primary}
        size='large'
        style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0, alignItems: 'center', justifyContent: 'center'}}
      />
    );
  }




support(){

                   let mail = support.mail;
                   let subject = support.appname+' '+support.device+' '+support.version;
                   let url = 'mailto:'+mail+'?cc=&subject='+subject;
                   Linking.openURL(url);

}




goBack(){
if ( this.refs.MyWebView !== undefined ){
    this.refs.MyWebView.bounceOutLeft();
    this.refs.MyWebView2.fadeOut();
}
setTimeout(() => {  this.props.close() }, 1000);
}


getScreenSize(){
    let w = Dimensions.get('window').width;
    let h = Dimensions.get('window').height;
    let isTablet = true;
    if ( h > w ){
        isTablet = false;
        if ( w > window.screen.width ){
            w = window.screen.width;
            h = window.screen.height-150;
        }
    }

    return { width: w, height: h, isTablet:isTablet };
}

getHeaderAndFooterHeight(){

    let height = Headerheight;
    if ( this.props.showKontakt ){
        height = HeaderAndFooterheight;
    }

return height;
}

onMessage(data){

    if ( data === 'close' ){

        this.goBack();
    }

}

  render() {



    return (

    <>
      <style type="text/css">{`
        @font-face {
          font-family: 'FontAwesome';
          src: url(${require('react-native-vector-icons/Fonts/FontAwesome.ttf')}) format('truetype');
        }
        @font-face {
          font-family: 'MaterialCommunityIcons';
          src: url(${require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf')}) format('truetype');
        }
      `}</style>

<Animatable.View ref={'MyWebView2'} animation="fadeIn" style={{ width: this.getScreenSize().width, height: this.getScreenSize().height, backgroundColor: MainColor.background}}>
           <Header
               statusBarProps={{ barStyle: 'light-content' }}
               leftComponent={
                           <TouchableOpacity style={{justifyContent:'center', alignItems:'flex-start',width:50, height:50}} onPress={()=>this.goBack() }>
                                        <Icon  size={24} name='arrow-left' type='material-community' color='#ffffff'/>
                                </TouchableOpacity>}
               centerComponent={<Text style={{ color: '#fff', fontSize: 16, fontWeight:'bold' }} >{this.props.titel}</Text>}
               containerStyle={Headerstyle}
           />
<Animatable.View ref={'MyWebView'} animation="bounceInLeft" style={{ position:'absolute', left: this.getScreenSize().isTablet?'25%':0, top:Headerheight, height:this.getScreenSize().height-this.getHeaderAndFooterHeight(), width:this.getScreenSize().isTablet?'50%':'100%', overflow: 'hidden'}}>
        <WebView
                                     ref="webview"
                                     source={{uri: this.props.url+'?'+new Date()}}
                                     style={{marginTop: 0, width: '100%', height:'100%'}}
                                     onNavigationStateChange={this._onNavigationStateChange.bind(this)}
                                     onMessage={(event) => { this.onMessage(event.nativeEvent.data); }}
                                     javaScriptEnabled = {true}
                                     domStorageEnabled = {true}
                                     startInLoadingState={true}
                                     renderLoading={this.ActivityIndicatorLoadingView}
                                     useWebKit={true}
                                     allowFileAccess={true}
                                     allowUniversalAccessFromFileURLs={true}
                                     originWhitelist={['*']}
                                   />
</Animatable.View>
{
this.props.showKontakt ?
<View style={{ position:'absolute', left: this.getScreenSize().isTablet?'25%':0, bottom:0, height:50, width:this.getScreenSize().isTablet?'50%':'100%', justifyContent:'center', backgroundColor: MainColor.background, flexDirection:'row'}}>

        <Text style={{ width:'60%', color: MainColor.primary, fontSize: 12, fontWeight:'bold', textAlign:'center', alignSelf:'center' }} >
        {appstrings().strings.weiterhelfen}</Text>

        <TouchableOpacity style={{marginTop:0, width:'20%', height:50, justifyContent:'center', alignItems:'center'}} onPress={()=>this.support() }>
                <Icon size={32} name='envelope' type='font-awesome' color={MainColor.primary}/>
        </TouchableOpacity>

</View>:null
}



</Animatable.View>

</>
    );
  }
}

